import { LoadingButton } from "@mui/lab";
import { Button, Grid, InputAdornment, Stack, TextField } from "@mui/material";
import { FormTextField } from "components/atoms";
import { CommonModal } from "components/molecules";
import { Formik, FormikProvider, useFormik } from "formik";
import { DownloadHelper } from "helpers";
import { IDownloadReceiveExportPalletLabel, IReceiveDetail } from "model";
import { useEffect, useState } from "react";
import { DownloadActions } from "redux/actions";
import {
  useAppDispatch,
  useAppSelector,
} from "redux/configurations/reduxHooks";
import { EXPORT_FILE_NAME } from "utils/Const";
import { I18nTranslator, translations } from "utils/i18n";
import * as yup from "yup";

export interface IExportPalletLabel {
  labelQuantity: number | string;
  quantityPerLabel: number | string;
}

const validationSchema = yup.object().shape({
  labelQuantity: yup
    .number()
    .min(1, "Số lượng ít nhất là 1")
    .required(translations.yupError.required),
  quantityPerLabel: yup
    .number()
    .min(1, "Số lượng ít nhất là 1")
    .required(translations.yupError.required),
});

const ExportPalletLabelModal = (props: {
  currentReceiveDetail?: IReceiveDetail;
  open: boolean;
  onClose(): void;
  onFinish(): void;
}) => {
  const dispatch = useAppDispatch();
  const { currentReceiveDetail, open, onClose, onFinish } = props;
  const downloading = useAppSelector(
    (state) => state.AppConfigReducer.downloading
  );

  const onDownloadPalletLotMaterial = (quantity: IExportPalletLabel) => {
    const params: IDownloadReceiveExportPalletLabel = {
      strQuantity: quantity.quantityPerLabel.toString(),
      stockReceivingCode: currentReceiveDetail?.stockReceivingCode!,
      stockReceivingHeaderId: currentReceiveDetail?.stockReceivingHeaderId!,
      stockRecevingDetailId: currentReceiveDetail?.id!,
      numberToPrint: quantity?.labelQuantity as number,
      fileName: `${EXPORT_FILE_NAME.receiveDetail}_[${currentReceiveDetail?.productLot}]`,
    };
    dispatch(DownloadActions.downloadReceiveExportPalletLabel.request(params));
  };

  useEffect(() => {
    if (!open) {
      formik.resetForm();
    }
  }, [open]);

  const renderFooter = () => {
    return (
      <Footer
        loading={downloading}
        onClose={onClose}
        onConfirm={formik.handleSubmit}
      />
    );
  };

  const formik = useFormik({
    initialValues: {
      labelQuantity: 0,
      quantityPerLabel: 0,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      onDownloadPalletLotMaterial(values);
    },
  });

  return (
    <CommonModal
      title={I18nTranslator(translations.receive.exportPalletLabel)}
      open={open}
      FooterComponent={renderFooter()}
      handleClose={onClose}
    >
      <Grid
        sx={{ width: "100%" }}
        container
        xs={12}
        alignItems="center"
        rowGap={2}
      >
        <FormikProvider value={formik}>
          <Grid container xs={12} item rowSpacing={2}>
            <Grid xs={12} item>
              <FormTextField
                id={"labelQuantity"}
                value={formik.values.labelQuantity}
                label={I18nTranslator(translations.receive.labelQuantity)}
                fullWidth
                type={"number"}
                InputProps={{
                  inputProps: {
                    min: 0,
                  },
                }}
              />
            </Grid>
            <Grid xs={12} item>
              <FormTextField
                id={"quantityPerLabel"}
                value={formik.values.labelQuantity}
                label={I18nTranslator(translations.receive.quantityPerLabel)}
                fullWidth
                type={"number"}
                InputProps={{
                  inputProps: {
                    min: 0,
                  },
                  // endAdornment: (
                  //   <InputAdornment position="end">
                  //     {currentReceiveDetail?.uom.toUpperCase()}
                  //   </InputAdornment>
                  // ),
                }}
              />
            </Grid>
          </Grid>
        </FormikProvider>
      </Grid>
    </CommonModal>
  );
};

const Footer = (props: {
  loading: boolean;
  onConfirm(): void;
  onClose(): void;
}) => {
  const { loading, onConfirm, onClose } = props;
  return (
    <Stack direction={"row"} spacing={2} justifyContent={"flex-end"}>
      <Button onClick={onClose}>
        {I18nTranslator(translations.button.cancel)}
      </Button>
      <LoadingButton loading={loading} onClick={onConfirm} variant="contained">
        {I18nTranslator(translations.button.export)}
      </LoadingButton>
    </Stack>
  );
};
export default ExportPalletLabelModal;
